import React, { useState, useEffect } from 'react';

import { useQuery } from "react-query";

import { fetchSAVFournisseurDepot } from 'utils/ts-queries';

import Skeleton from '@mui/material/Skeleton';

import { TextField } from '@mui/material';

type Props = {
    name: string,
    label: string,
    fournisseurId: number,
    codeDepot: string,
    value: string,
    onChange: ( event: {target: {name:string, value:string}} ) => void
}

function NumeroCompteFoussierTextField({name, label, fournisseurId, codeDepot, value, onChange} : Props) {

    const [numeroCompteFoussier, setNumeroCompteFoussier] = useState<string>('');
    const [helperText, setHelperText] = useState<string>('');
    
    const { isLoading, isError, data } =
        useQuery({
            queryKey: [
                'SAVFournisseurDepot',
                fournisseurId,
                codeDepot
            ],
            queryFn: () => fetchSAVFournisseurDepot({
                fournisseurId,
                codeDepot
            }),
            retry: false,
        })

        
    // useEffect(function loadingChanged () {
    //     console.log({isLoading});
    // }, [isLoading]);
    

    useEffect(function errorChanged () {
        // console.log("errorChanged");
        setHelperText("Numéro inconnu pour ce founisseur sur ce dépot, veuillez le saisir.");
        setNumeroCompteFoussier('');
        onChange({ target: { name: name, value: ''}});
    }, [isError]);      

    useEffect(function dataChanged () {

        if(isLoading)
        {
            return;
        }
        if(data && data.numeroCompte && data.numeroCompte !== numeroCompteFoussier)
        {
            setHelperText(`Numéro prérempli pour ce founisseur sur ce dépot : ${data.numeroCompte}`);
            setNumeroCompteFoussier(data.numeroCompte);
            onChange({ target: { name: name, value: data.numeroCompte}});
        }
        else
        if(data && data.numeroCompte && data.numeroCompte === numeroCompteFoussier)
        {
            // No Change
        }
        else
        {
            setHelperText("Numéro inconnu pour ce founisseur sur ce dépot, veuillez le saisir.");
            setNumeroCompteFoussier('');
            onChange({ target: { name: name, value: ''}});
        }

    }, [data, isLoading, numeroCompteFoussier]);  


    return (
        <>            
            {isLoading && (<Skeleton />)}
            
            {!isLoading && (
                <TextField style={{ paddingBottom: '8px' }}
                    name={name}
                    label={label}
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                        shrink: true
                    }}
        
                    value={value}
                    onChange={onChange}     
                    helperText={helperText}            
                />
            )}

        </>
    );
  
}


export default NumeroCompteFoussierTextField